<template>
	<div class="sidebar">
		<a href="/" class="nostyle logo">
			<img src="/static/images/block_sm.png" alt="">
		</a>
		<ul class="sidebarItemList">
			<sidebar-item
				v-bind:key="item.name"
				v-for="item in items"
				:name="item.name"
				:target-id="item.targetId"
				:icon-class="item.iconClass"
				:scroll-to-speed=scrollToSpeed
			/>
		</ul>
		<a href="mailto:daniel.junior.dube@gmail.com" class="nostyle mail_to">
			<i class="fas fa-fw fa-envelope" aria-hidden="true"></i>
		</a>
	</div>
</template>

<script>
	import SidebarItem from './sidebarItem'
	export default {
		name: "Sidebar",
		props: ["scrollToSpeed"],
		components: {
			SidebarItem,
		},
		data () {
			return {
				items: [
					{
						name: "Landing",
						targetId: "#title_section",
						iconClass: "fas fa-user-circle"
					},
					{
						name: "Experiences",
						targetId: "#experiences_section",
						iconClass: "fa-briefcase"
					},
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/global.scss";
	@import "../../styles/text_mixins.scss";
	@import "../../styles/position_mixins.scss";
	@import "../../styles/spacing_mixins.scss";
	@import "../../styles/dimension_mixins.scss";
	@import "../../styles/transition_mixins.scss";
	@import "../../styles/background_mixins.scss";

	.sidebar {
		color: black;
		@include position( $position: fixed, $z-index: 9999 );
		@include background(
			$color: $light_contrast,
			$box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3)
		);
		@include dimensions( 50px, 100vh );
		& .logo img {
			@include spacing( 5px 0px 0px 0px, 5px );
			@include dimensions( 40px, 40px );
		}
		& .sidebarItemList {
			list-style: none;
			@include spacing( 5px 0px 0px 0px, 0px );
		}
		& a.mail_to {
			line-height: 50px;
			@include position( block, absolute, $bottom: 5px );
			@include spacing( 0px, 0px );
			@include content_position( center, center );
			@include dimensions( 50px, 50px );
			&:hover {
				& i {
					color: $accent;
					@include background(
						$color: black,
						$border-radius: 3px
					);
					@include transition( 0.1s ease-in );
				}
			}
			& i {
				position: absolute;
				@include spacing( 5px, 0px );
				@include dimensions( 40px, 40px );
				font-size: 25px;
				line-height: 40px;
				@include transition( 0.2s ease-in );
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/sidebar.vue